import PersonIcon from '@mui/icons-material/Person';
import { Box, Typography, Avatar, Grid } from '@mui/material';
import { useAppSelector } from '@/store/hooks';
import { StyledCard } from './profile.styles';

const Label = ({ label, value }: { label: string; value: string }) => (
  <Box
    sx={{
      width: '100%',
      minWidth: 0,
    }}
  >
    <Typography
      variant="caption"
      sx={{
        color: '#9CA3AF',
        textTransform: 'uppercase',
        fontWeight: 600,
        display: 'block',
        mb: 0.5,
        wordBreak: 'break-word',
      }}
    >
      {label}
    </Typography>

    <Typography
      variant="body1"
      fontWeight={500}
      sx={{
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
      }}
    >
      {value}
    </Typography>
  </Box>
);

const Profile = () => {
  const { userProfile } = useAppSelector((state) => state.auth);

  const fullName = `${userProfile?.firstName ?? ''} ${userProfile?.lastName ?? ''}`.trim();

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        overflowX: 'hidden',
        boxSizing: 'border-box',
        px: { xs: 1.5, sm: 2, md: 3 },
        py: 2,
      }}
    >
      <Box
        sx={{
          mb: 3,
          width: '100%',
        }}
      >
        <Typography
          variant="h5"
          fontWeight={600}
          sx={{
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
            wordBreak: 'break-word',
          }}
        >
          View Profile
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mt: 0.5,
            wordBreak: 'break-word',
          }}
        >
          Manage your Hello Refi profile and preferences.
        </Typography>
      </Box>

      <StyledCard>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'center', sm: 'center' },
            textAlign: { xs: 'center', sm: 'left' },
            gap: 2,
            width: '100%',
            minWidth: 0,
          }}
        >
          <Avatar
            sx={{
              width: { xs: 72, sm: 80 },
              height: { xs: 72, sm: 80 },
              bgcolor: '#E6F4F1',
              color: '#00aa8f',
              flexShrink: 0,
            }}
          >
            <PersonIcon fontSize="large" />
          </Avatar>

          <Box
            sx={{
              width: '100%'
            }}
          >
            <Typography
              variant="h6"
              fontWeight={600}
              sx={{
                wordBreak: 'break-word',
              }}
            >
              {fullName || ''}
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                mt: 0.5,
                wordBreak: 'break-word',
              }}
            >
              {userProfile?.emailId || ''}
            </Typography>
          </Box>
        </Box>
      </StyledCard>

      <StyledCard style={{ marginTop: 16 }}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2 }}
        >
          Personal Information
        </Typography>

        <Grid
          container
          spacing={2}
          sx={{
            width: '100%',
            margin: 0,
          }}
        >
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              pl: '0 !important',
              pt: '0 !important',
            }}
          >
            <Label
              label="Full Name"
              value={fullName || ''}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              pl: { xs: '0 !important', sm: '16px !important' },
              pt: { xs: '16px !important', sm: '0 !important' },
            }}
          >
            <Label
              label="Email Address"
              value={userProfile?.emailId || ''}
            />
          </Grid>
        </Grid>
      </StyledCard>
    </Box>
  );
};

export default Profile;